import RobotVacuumsInsiderLogo from './logo'
import {robotVacuumsInsiderStylesUS} from './styles'

const baseConfig = {
  domainName: 'robotvacuumsinsider' as const,
  domainType: 'insider' as const,
  siteName: 'Robot Vacuums Insider',
  logo: <RobotVacuumsInsiderLogo className="size-10 shrink-0 tablet:size-8" />,
  favicon: '/favicons/robotvacuumsinsider.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-9561CD8VGL',
    camelCaseUrl: 'RobotVacuumsInsider.com',
    title: (category: string, count: string) =>
      `Robot vacuums Insider | Top ${count} Pro Insider Choices for ${category}`,
    description: (_category?: string, count?: string) =>
      `Clean floors, minimal effort. Robot Vacuum Insider shares the top ${count} picks for every home. Find the perfect robot for your needs.`,
    styles: robotVacuumsInsiderStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
